/** @format */

import React, {FC, useCallback, useEffect, useMemo, useState} from "react";
import {ActivityIndicator, KeyboardAvoidingView, Platform, ScrollView, StyleSheet, Text, View,} from "react-native";
import Dropdown from "../../components/Dropdown";
import {styles} from "../../theme/styles";
import useAuth from "../../contexts/Auth/useAuth";
import HeaderWrap from "../../components/Header";
import {Storage, Store} from "../../utils/Storage";
import WB from "../../Icons/WB";
import {useAppContext} from "../../contexts/AppContext";
import {NavigationProp, useNavigation} from "@react-navigation/native";
import {HomeTabsParams} from "../../navigation/AppStack/HomeTabParams";
import {CircumstancesType, NeuroDetailsType} from "../../constants";
import {AppTheme, useTheme} from "../../theme/colors";
import CustomTextInput, {CustomTextInputChangeEvent,} from "../../components/CustomTextInput";
import Checkbox, {CheckboxPressEvent} from "../../components/Checkbox";
import {arraysAreEqual, updatePassportAndWellbeingFormData,} from "../../utils/passport.utils";
import {RasaUtils} from "../../utils/Rasa.utils";
import {ProfileStackRoute} from "../../navigation/AppStack/routes";
import {ShareScreenRoute} from "../../navigation/ProfileStack/routes";
import {RASA_HOST, WEB_MAXWIDTH} from "../../../constants";
import SaveButton from "../../components/SaveButton";
import {getErrorMessage} from "../../utils/errorFormHandlers";
import {IsMobile} from "../../theme";

export interface ImpactFormInterface {
    passport_strategies: string;
    passport_network: string;
    passport_signs: string;
    passport_triggers: string;
    passport_impact: string;
    passport_aspects: string;
    mh_issues_current: string;
    mh_issues_past: string;
    mh_challenges: string;
    neuro_details: NeuroDetailsType[];
    neuro_diagnosed: string;
    neuro_challenges: string;
    wb_current: string;
    wb_past: string;
    wb_challenges: string;
    disabilty_details: string;
    disabilty_difficulties: string;
    disabilty_challenges: string;
}

const defaultWellBeingFormValues: ImpactFormInterface = {
    passport_strategies: "",
    passport_network: "",
    passport_signs: "",
    passport_triggers: "",
    passport_impact: "",
    passport_aspects: "",
    mh_issues_current: "",
    mh_issues_past: "",
    mh_challenges: "",
    neuro_details: [],
    neuro_diagnosed: "",
    neuro_challenges: "",
    wb_current: "",
    wb_past: "",
    wb_challenges: "",
    disabilty_details: "",
    disabilty_difficulties: "",
    disabilty_challenges: "",
};

const handleUpdate = async () => {

}

const WellBeing: FC = () => {
    const [loading, setLoading] = useState(false);
    const {user, profileMoods, setProfileMoods} = useAuth();
    const [wellBeingFormData, setWellBeingFormData] =
      useState<ImpactFormInterface>(defaultWellBeingFormValues);
    const navigation = useNavigation<NavigationProp<HomeTabsParams>>();
    const {passportData, setPassportData} = useAuth();
    const [isFormValueChange, setIsFormValueChange] = useState<boolean>(false);
    const [id, setId] = useState<string>("");
    const theme = useTheme();
    const customStyles = getStyles(theme);
    const storedSubDataKey = "sub";
    const {setErrorItems, errorItems, saveStatus, setSaveStatus, mode, data} = useAppContext();
    const [isSharePressed, setIsSharePressed] = useState(false);

    useEffect(() => {
        ///fetching the data from the rasa context whenever wellbeing screen is mounted
        const fetchRasaContext = async () => {
            const id =
              ((await Storage.getValue(storedSubDataKey)) as string) ?? "";
            setId(id);
            if (id) {
                const rasaUtils = new RasaUtils(RASA_HOST);
                if (user && user.token && user.token.jwtToken) {
                    const rasaContext = await rasaUtils.retrieveContext(id, user.token.jwtToken);
                    await rasaUtils.saveContext(
                      rasaContext
                    );
                }
            }
            const storedData = await Storage.getStorage();
            const updatedFormData =
              updatePassportAndWellbeingFormData(storedData);

            setWellBeingFormData((prev) => ({
                ...prev,
                ...updatedFormData,
            }));
        };
        if (passportData) fetchRasaContext();
    }, []);

    useEffect(() => {
        //Getting wellbeing Form data From the storage
        const updateFormDataFromStorage = async () => {
            if (data) {
                const _data = await Storage.getStorage();
                const getWellBeingFormData =
                  updatePassportAndWellbeingFormData(_data);

                setWellBeingFormData((prev) => ({
                    ...prev,
                    ...getWellBeingFormData,
                }));
            }
        };

        updateFormDataFromStorage();
    }, [data, mode, passportData]);

    const neuroDiagnosedOptions = useMemo(() => {
        return ["Diagnosed", "Undiagnosed", "Awaiting Referral"];
    }, []);

    const onPressShare = useCallback(async () => {
        setIsSharePressed(true);
        await Storage.setValue("form_updated", true);



        navigation.navigate(ProfileStackRoute, {
            screen: ShareScreenRoute,
        });
    }, [isFormValueChange, user?.token]);


    const onChangeTextField = async (event: CustomTextInputChangeEvent) => {
        const {name, value} = event;
        setSaveStatus(false);

        await Storage.setValue(name, value);
        await Storage.setValue("form_changed", true);

    };


    const onNeuroDetailsCheckboxes = async (event: CheckboxPressEvent) => {
        const {name, checked} = event;
        const data = (await Storage.getValue("neuro_details")) ?? [];
        let tempArr = data as NeuroDetailsType[];
        if (checked) {
            tempArr = [...tempArr, name as NeuroDetailsType];
        } else {
            tempArr = tempArr.filter((val) => val !== name);
        }
        await Storage.setValue("neuro_details", tempArr);
        setWellBeingFormData((prevState) => ({
            ...prevState,
            neuro_details: tempArr,
        }));
        setSaveStatus(false);
        await Storage.setValue("form_changed", true);
    };

    const renderNeuroDetailsCheckboxes = () => {
        return (
          <View>
              <Text style={{fontSize: 14, fontWeight: "300"}}>
                  What is your Neurodiversity
              </Text>
              <Checkbox
                name={NeuroDetailsType.AUTISM}
                text={NeuroDetailsType.AUTISM}
                checked={wellBeingFormData.neuro_details.includes(
                  NeuroDetailsType.AUTISM
                )}
                onPressCheckbox={onNeuroDetailsCheckboxes}
              />
              <Checkbox
                name={NeuroDetailsType.ADHD}
                text={NeuroDetailsType.ADHD}
                checked={wellBeingFormData.neuro_details.includes(
                  NeuroDetailsType.ADHD
                )}
                onPressCheckbox={onNeuroDetailsCheckboxes}
              />
              <Checkbox
                name={NeuroDetailsType.DYSLEXIA}
                text={NeuroDetailsType.DYSLEXIA}
                checked={wellBeingFormData.neuro_details.includes(
                  NeuroDetailsType.DYSLEXIA
                )}
                onPressCheckbox={onNeuroDetailsCheckboxes}
              />
              <Checkbox
                name={NeuroDetailsType.DYSCALCULIA}
                text={NeuroDetailsType.DYSCALCULIA}
                checked={wellBeingFormData.neuro_details.includes(
                  NeuroDetailsType.DYSCALCULIA
                )}
                onPressCheckbox={onNeuroDetailsCheckboxes}
              />
              <Checkbox
                name={NeuroDetailsType.OTHER}
                text={NeuroDetailsType.OTHER}
                checked={wellBeingFormData.neuro_details.includes(
                  NeuroDetailsType.OTHER
                )}
                onPressCheckbox={onNeuroDetailsCheckboxes}
              />
          </View>
        );
    };

    const getNeuroDiagnosedValue = async () => {
        const storedValue = await Storage.getValue("neuro_diagnosed");
        return storedValue || "Select an option";
    };


    const renderNeuroDiagnosedSelectOptions = () => {
        const [selectedValue, setSelectedValue] = useState("");

        useEffect(() => {
            const fetchDefaultValue = async () => {
                const storedValue = await Storage.getValue("neuro_diagnosed");
                setSelectedValue(storedValue || ""); // Set default or fallback to an empty string
            };
            fetchDefaultValue();
        }, []);


        return (
          <View style={{gap: 10}}>
              <Text style={{fontSize: 14, fontWeight: "300"}}>
                  Is your Neurodiversity diagnosed, undiagnosed or on a
                  referral pathway
              </Text>
              <View style={{paddingHorizontal: 10, gap: 15}}>
                  <Dropdown
                    defaultButtonText={selectedValue || "Select an option"}
                    //defaultValue={getNeuroDiagnosedValue()}
                    onSelect={async (value) => {
                        await Storage.setValue("neuro_diagnosed", value);
                        setWellBeingFormData((prevState) => {
                            return {
                                ...prevState,
                                neuro_diagnosed: value,
                            };
                        });
                        setSaveStatus(false);
                        await Storage.setValue("form_changed", true);

                        return value;
                    }}
                    label="Neurodiversity"
                    simple
                    data={neuroDiagnosedOptions}
                  />
              </View>
          </View>
        );
    };

    return loading ? (
      <View
        style={[
            styles.flex1,
            styles.center,
            {backgroundColor: theme.BACKGROUND},
        ]}
      >
          <ActivityIndicator size="large" color={theme.ACCENT}/>
      </View>
    ) : (
      <HeaderWrap
        onPressShare={onPressShare}
        Icon={
            <WB
              transform={[{translateX: -10}]}
              color={isSharePressed ? '#B0B0B0' : '#FFFFFF'}
              width={isSharePressed ? 50 : 40}
              height={isSharePressed ? 50 : 40}
            />
        }
      >
          <>
              <KeyboardAvoidingView
                style={
                  {flex: 1, backgroundColor: theme.BACKGROUND},
                    !IsMobile && { width: WEB_MAXWIDTH, alignSelf: "center"}
              }
                behavior={Platform.select({
                    ios: "padding",
                    android: "height",
                })}
                keyboardVerticalOffset={Platform.OS === "ios" ? 60 : 0}
              >
                  <ScrollView
                    style={{flex: 1}}
                    scrollEventThrottle={1600}
                    showsVerticalScrollIndicator={false}
                    contentContainerStyle={{
                        gap: 20,
                        padding: 20,
                        paddingBottom: 60,
                    }}
                  >
                      <Text style={styles.title}>Make the passport yours</Text>
                      <CustomTextInput
                        name="passport_impact"
                        title="Areas of my life impacting wellbeing"
                        placeholder="Passport Impact"
                        defaultValue={wellBeingFormData.passport_impact}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                      />
                      <CustomTextInput
                        name="passport_triggers"
                        title="Mental health and neurodiveristy triggers"
                        placeholder="Passport Triggers"
                        defaultValue={wellBeingFormData.passport_triggers}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                      />
                      <CustomTextInput
                        name="passport_strategies"
                        title="Support strategies"
                        placeholder="Passport strategies"
                        defaultValue={wellBeingFormData.passport_strategies}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                      />
                      <CustomTextInput
                        name="passport_signs"
                        title="Signs my mental health is getting worse "
                        placeholder="Passport signs"
                        defaultValue={wellBeingFormData.passport_signs}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                      />
                      <CustomTextInput
                        name="passport_network"
                        title="What would I like my support network to do when they notice signs of worsen health"
                        placeholder="Passport Network"
                        defaultValue={wellBeingFormData.passport_network}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                      />
                      <CustomTextInput
                        name="passport_aspects"
                        title="Positives aspects of life / things I’m good at"
                        placeholder="Passport Aspects"
                        defaultValue={wellBeingFormData.passport_aspects}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                      />
                      <CustomTextInput
                        name="mh_issues_current"
                        title="Current mental health issues (e.g. anxiety, low mood, depression, panic, bi-polar, psychosis)"
                        placeholder="Mental Health Issues Current"
                        defaultValue={wellBeingFormData.mh_issues_current}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={
                            !mode.includes(CircumstancesType.MENTAL_HEALTH)
                        }
                      />
                      <CustomTextInput
                        name="mh_issues_past"
                        title="Past mental health issues (e.g. anxiety, low mood, depression, panic, bi-polar, psychosis)"
                        placeholder="Mental Health Issues Past"
                        defaultValue={wellBeingFormData.mh_issues_past}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={
                            !mode.includes(CircumstancesType.MENTAL_HEALTH)
                        }
                      />
                      <CustomTextInput
                        name="mh_challenges"
                        title="Mental health challenges ( e.g. workload, deadlines, group work, presentations, exams, conflict with peers, financial worries, relationship issues, social situations, housing, travel, integration into UK culture)"
                        placeholder="Mental Health Challenges"
                        defaultValue={wellBeingFormData.mh_challenges}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={
                            !mode.includes(CircumstancesType.MENTAL_HEALTH)
                        }
                      />
                      {mode.includes(CircumstancesType.NEURODIVERSITY) &&
                        renderNeuroDetailsCheckboxes()}
                      {mode.includes(CircumstancesType.NEURODIVERSITY) &&
                        renderNeuroDiagnosedSelectOptions()}
                      <CustomTextInput
                        name="neuro_challenges"
                        title="Neurodiversity challenges (e.g. workload, deadlines, group work, presentations,
              exams, conflict with peers, financial worries, relationship issues, social situations,
              sensory overload, noisy environment, stimming in private, travel, writing or reading)"
                        placeholder="Neuro Challenges"
                        defaultValue={wellBeingFormData.neuro_challenges}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={
                            !mode.includes(CircumstancesType.NEURODIVERSITY)
                        }
                      />
                      <CustomTextInput
                        name="wb_current"
                        title="Current wellbeing issues (e.g. bereavement, relationship breakdown, financial
              stress, workload stress…)"
                        placeholder="Wellbeing Current"
                        defaultValue={wellBeingFormData.wb_current}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={!mode.includes(CircumstancesType.WELLBEING)}
                      />
                      <CustomTextInput
                        name="wb_past"
                        title="Past wellbeing issues (e.g. bereavement, relationship breakdown, financial stress, workload stress…) "
                        placeholder="Wellbeing Past"
                        defaultValue={wellBeingFormData.wb_past}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={!mode.includes(CircumstancesType.WELLBEING)}
                      />
                      <CustomTextInput
                        name="wb_challenges"
                        title="Wellbeing challenges ( e.g. attendance, communication, withdrawing, connecting with
              others, accessing support, homesickness, productivity…)"
                        placeholder="Wellbeing Challenges"
                        defaultValue={wellBeingFormData.wb_challenges}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={!mode.includes(CircumstancesType.WELLBEING)}
                      />
                      <CustomTextInput
                        name="disabilty_details"
                        title="What is your disability"
                        placeholder="Disability Details"
                        defaultValue={wellBeingFormData.disabilty_details}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={!mode.includes(CircumstancesType.DISABILITY)}
                      />
                      <CustomTextInput
                        name="disabilty_difficulties"
                        title="Difficulties due to disability "
                        placeholder="Disability Difficulties"
                        defaultValue={wellBeingFormData.disabilty_difficulties}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        multiline
                        hideInput={!mode.includes(CircumstancesType.DISABILITY)}
                      />
                      <CustomTextInput
                        name="disabilty_challenges"
                        title="Disability-related challenges"
                        placeholder="Disability Challenges"
                        defaultValue={wellBeingFormData.disabilty_challenges}
                        onChangeText={onChangeTextField}
                        fieldStyles={customStyles.input}
                        scrollEnabled={false}
                        onFocus={() => {
                        }}
                        multiline
                        hideInput={!mode.includes(CircumstancesType.DISABILITY)}
                      />
                      {getErrorMessage(errorItems, "global") ?
                        <Text style={styles.errorText}>{getErrorMessage(errorItems, "global")}</Text> : null}
                      <SaveButton onSave={handleUpdate} disable={saveStatus}/>
                  </ScrollView>
              </KeyboardAvoidingView>
          </>
      </HeaderWrap>
    );
};

export default WellBeing;

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
      input: {
          backgroundColor: theme.BACKGROUND,
          borderBottomColor: "#ddd",
          borderBottomWidth: 1,
          paddingVertical: 5,
          paddingHorizontal: 0,
      },
  });
